import { createSlice } from "@reduxjs/toolkit";

export const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    modelpopup: false,
    UserAccountAddr: '',
    UserAccountBal: 0,
    providerss: null,
    Service_Fee_buyer: 0,
    Service_Fee_seller: 0,
    Wen_Bln: 0,
    Accounts: '',
    WalletConnected: '',
    AddressUserDetails: null,
    tokenAddress: {},
    tokenAddressETH: {},
    tokenAddressBSC: {},
    networkoption: {},
    swapFee: 0,
    currency_convertion: 0,
    networkConfiguration: {
      currencySymbol: '',
      tokenSymbol: '',
      tokenABI: {},
      tokenAddr: {},
      singleContract: "",
      multipleContract: "",
      trade: "",
      BNBPROVIDER: "",
      networkVersion: '',
      chainId: '',
      Chainid: 0,
    }
  },
  reducers: {
    wallet_connect_context: (state, action) => {
      return {
        ...state,
        ...action.payload
      };
    }
  }
});

export const { wallet_connect_context } = adminSlice.actions;
export default adminSlice.reducer;
